var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("p", { staticClass: "d-flex align-items-center" }, [
        _c("span", {
          staticClass: "icon icon-hands-free font-size-24",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("span", {
          staticClass: "ms-1 fw-bold",
          domProps: { innerHTML: _vm._s(_vm.text) },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }